var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5083 9.3501V13.0918C2.5083 16.8334 4.0083 18.3334 7.74997 18.3334H12.2416C15.9833 18.3334 17.4833 16.8334 17.4833 13.0918V9.3501",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 9.99984C11.5252 9.99984 12.6502 8.75817 12.5002 7.23317L11.9502 1.6665H8.05857L7.50024 7.23317C7.35024 8.75817 8.47524 9.99984 10.0002 9.99984Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2585 9.99984C16.9418 9.99984 18.1751 8.63317 18.0085 6.95817L17.7751 4.6665C17.4751 2.49984 16.6418 1.6665 14.4585 1.6665H11.9168L12.5001 7.50817C12.6418 8.88317 13.8835 9.99984 15.2585 9.99984ZM4.70015 9.99984C6.07515 9.99984 7.31681 8.88317 7.45015 7.50817L7.63348 5.6665L8.03348 1.6665H5.49181C3.30848 1.6665 2.47515 2.49984 2.17515 4.6665L1.95015 6.95817C1.78348 8.63317 3.01681 9.99984 4.70015 9.99984ZM10.0001 14.1665C8.60848 14.1665 7.91681 14.8582 7.91681 16.2498V18.3332H12.0835V16.2498C12.0835 14.8582 11.3918 14.1665 10.0001 14.1665Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.3b4f4eebb18f3ca16d258eab6242fc64.svg";
export { ForwardRef as ReactComponent };